import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { CSSAttribute } from '../../types';
import { useAdParameters } from '../hooks/useAdParameters';
import { useCTAColor } from '../hooks/useCTAColor';
import { useTextKeywords } from '../hooks/useTextKeywords';
import { getLocaleForLanguage } from '../locales';
import { isRtlLanguage } from '../rtl-languages';
import { headBg, ig_tag, typography } from '../theme';
import cta_svg from './cta.svg';
import { highlightTags } from './lib';
import { LineClamp } from './line-clamp';

const cta = {
  boxSizing: 'border-box',
  paddingBlockStart: 8,
  paddingBlockEnd: 8,
  paddingInlineStart: 16,
  paddingInlineEnd: 16,
  ...typography.primary,
  fontWeight: 600,
  color: headBg,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '40px',
};

const ctaTextContainer = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const ctaArrowMirror = {
  transform: 'scale(-1)',
  transformOrigin: 'center center',
};

const brand_text = { marginInlineEnd: '4px', ...typography.primary, fontWeight: 600 };
const footer_text = {
  background: headBg,
  paddingBlockStart: 12,
  paddingBlockEnd: 16,
  paddingInlineStart: 16,
  paddingInlineEnd: 16,
};

function prefixElement(text: string, style: CSSAttribute) {
  const prefixElement = document.createElement('span');
  Object.assign(prefixElement.style, style);
  prefixElement.appendChild(document.createTextNode(text));
  return prefixElement;
}

export function InstagramFooter() {
  const { config = {} } = useAdParameters<any>();
  const { brand_name, text, callToAction } = config;

  const locale = getLocaleForLanguage(config.ctaLanguage);
  const textWithKeywords = useTextKeywords(text, locale);

  const [normalCTAColor] = useCTAColor(config.ctaColor);
  const ctaStyle = useMemo(
    () => ({
      ...cta,
      background: normalCTAColor,
    }),
    [normalCTAColor]
  );
  const isRtl = isRtlLanguage(config.ctaLanguage);

  return (
    <div>
      {callToAction !== null && (
        <div style={ctaStyle}>
          <span style={ctaTextContainer}>{callToAction} </span>{' '}
          <img alt={callToAction} src={cta_svg} style={isRtl ? ctaArrowMirror : undefined} />
        </div>
      )}
      {text && (
        <div style={footer_text}>
          <LineClamp
            prefix={prefixElement(brand_name, brand_text)}
            text={textWithKeywords}
            lines={3}
            lineHeight={18}
            dots={true}
            style={typography.primary}
            styleWord={highlightTags(ig_tag)}
            keywords
          />
        </div>
      )}
    </div>
  );
}
